'use client';

import { useTranslations } from 'next-intl';
import Slider from 'rc-slider/lib/Slider';
import { roundToNDecimal } from '~/utils/utils';

export const VASResult = ({
  average,
  limitMax,
  limitMin,
  type,
}: VASResultPropsType) => {
  const t = useTranslations('SURVEY.RESULTS');
  const roundAverage = roundToNDecimal(average);

  return (
    <div className="vas" data-testid="vas">
      <div className="vas__average" data-testid="vas-average">
        {t.rich('AVERAGE', {
          roundAverage,
        })}
      </div>
      <Slider
        className={`VAS ${type} VASResult`}
        defaultValue={roundAverage}
        value={roundAverage}
        min={limitMin}
        max={limitMax}
        step={0.1}
      />
      <div className="vas__labels">
        <span data-testid="vas-labels">{limitMin}</span>
        <span data-testid="vas-labels">{limitMax}</span>
      </div>
    </div>
  );
};

interface VASResultPropsType {
  average: number;
  limitMax: number;
  limitMin: number;
  type: string;
}
